import { render } from "./AboutSection.vue?vue&type=template&id=18e7bde7&scoped=true"
const script = {}

import "./AboutSection.vue?vue&type=style&index=0&id=18e7bde7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e7bde7"]])

export default __exports__